<label class="container" ngClass={{radioClass}}>
  <div *ngIf="radioText" class="radiobutton__text">{{radioText}}</div>
  <input type="radio" [checked]='defaultCheck' (change)="handleCheckboxChange($event)" name="{{radioName || 'radio'}}">
  <span class="checkmark"></span>
</label>
